import { 
  Mic, 
  MessageSquare, 
  BookOpen, 
  Users2, 
  Crown, 
  Handshake 
} from "lucide-react";

const areas = [
  {
    icon: Mic,
    title: "Presenting with Impact",
    description: "Build confidence and command presence when speaking to any audience",
  },
  {
    icon: MessageSquare,
    title: "Voice, Breath & Body",
    description: "Connect with your physical presence and use your voice effectively",
  },
  {
    icon: BookOpen,
    title: "Storytelling & Communication",
    description: "Craft and deliver compelling narratives that resonate",
  },
  {
    icon: Users2,
    title: "Difficult Conversations",
    description: "Navigate challenging discussions with clarity and empathy",
  },
  {
    icon: Crown,
    title: "Authentic Leadership",
    description: "Lead with self-awareness and genuine presence",
  },
  {
    icon: Handshake,
    title: "Team Connection",
    description: "Foster collaboration and psychological safety within teams",
  },
];

export default function CoreAreasSection({ isVisible }) {
  return (
    <section
      id="core-areas"
      className={`py-24 lg:py-32 bg-[#EAE3D9] transition-all duration-700 ${
        isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"
      }`}
      data-testid="core-areas-section"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="font-['Cormorant_Garamond'] text-3xl sm:text-4xl lg:text-5xl font-medium text-[#1A1A1A] mb-6 heading-decorated-center">
            Core Areas of Work
          </h2>
          <p className="font-['Manrope'] text-base lg:text-lg text-[#4A4542] max-w-2xl mx-auto">
            I work with individuals and teams across these interconnected areas,
            tailoring each session to specific needs and challenges.
          </p>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {areas.map((area, index) => (
            <div
              key={area.title}
              className="group bg-[#F9F6F0] p-8 border border-[#C5A059]/30 card-hover"
              data-testid={`core-area-card-${index}`}
            >
              <div className="w-12 h-12 bg-[#1A1A1A] flex items-center justify-center mb-6 group-hover:bg-[#8B5A2B] transition-colors">
                <area.icon
                  size={24}
                  strokeWidth={1.5}
                  className="text-[#F9F6F0]"
                />
              </div>
              <h3 className="font-['Cormorant_Garamond'] text-xl lg:text-2xl font-medium text-[#1A1A1A] mb-3">
                {area.title}
              </h3>
              <p className="font-['Manrope'] text-sm text-[#4A4542]">
                {area.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
